import { IonIcon } from '@ionic/react';
import React, { useMemo } from 'react';
import { ReviewStatusType } from '../../../../types/reviewStatus';
import {
  getDocReviewStatusIcon,
  docReviewStatusStyle,
} from '../ui/reviewStyle';
import DocStatusTag from '../ui/DocStatusTag';

type Props = {
  status: ReviewStatusType;
  filePurpose: string;
  fileName?: string;
};

export default function RequiredDocCard({
  status,
  filePurpose,
  fileName,
}: Props) {
  const statusIcon = useMemo(() => getDocReviewStatusIcon(status), [status]);

  const statusStyle = docReviewStatusStyle(status);
  return (
    <div className="flex items-start gap-2 p-2 w-full border border-border rounded-md">
      <div className="flex items-start gap-2 flex-1 min-w-0">
        <div className={`${statusStyle} w-5 h-5 p-2 box-content rounded-md`}>
          <IonIcon icon={statusIcon} className="size-5" />
        </div>
        <div className="flex-1 min-w-0">
          <p
            title={filePurpose}
            className="hig-emphasis-text truncate font-semibold"
          >
            {filePurpose}
          </p>
          {fileName && (
            <small
              title={fileName}
              className="medium-emphasis-text block truncate "
            >
              {fileName}
            </small>
          )}
        </div>
      </div>
      <div className="w-fit ml-auto">
        <DocStatusTag status={status} />
      </div>
    </div>
  );
}
